import instance from "../../utils/instance";

class DepartmentService {
    async getTreeData() {
        return await instance.post('/oa/common/treeControl/getTreeData',{
            type: "base_department"
        });
    }
}

export default new DepartmentService();